module.exports = __webpack_public_path__ + "img/person-ski-lift.f3a0fafc.svg";